import React, {useState, FC} from 'react';
import styles from "./authentication.module.scss";
import logo from "../../assets/images/83b-logo-corpora.png";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import SignUpForm, {TSignUpValues} from "./components/SignUpForm";
import ConfirmSignUpForm, {TConfirmValues} from "./components/ConfirmSignUpForm";
import { useNavigate } from 'react-router-dom';
import {useToast} from "../../hooks/useToast";
import {extractErrorMessage} from "../../helpers/extractErrorMessage";

import { InputText } from 'primereact/inputtext';
import moment from "moment/moment";
const baseUrl = import.meta.env.VITE_CORPORA_SERVICE_URL;

interface TSignUpProps {
    isQuickUse?: boolean;
    onSignedUpSuccess?: () => void;
}

const SignUp: FC<TSignUpProps> = ({ isQuickUse, onSignedUpSuccess }) => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [isLoading, setLoading] = useState<boolean>(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userInfo = sessionStorage.getItem('userInfo');
    const userInfoObj = userInfo ? JSON.parse(userInfo) : {};
    const email = searchParams.get('email') || userInfoObj?.email;
    const name = searchParams.get('name') || userInfoObj?.name;
    const decodedEmail = email ? decodeURIComponent(email) : '';
    const [formError, setFormErrorValue] = useState<string>('');
    const { show } = useToast();

    const clearFormError = () => {
        setFormErrorValue('');
    }

    const onSubmitSignUpForm = (values: TSignUpValues) => {
        setLoading(true);
        const params = {
            name: values.name,
            email: values.email,
            password: values.password,
        };
        axios.post(`${baseUrl}api/auth/sign-up`, params)
            .then((response) => {
                if (response?.status === 201) {
                    setUsername(values.email);
                }
                setLoading(false);
            })
            .catch((error) => {
                const errorData = {
                    error: error,
                    show: show,
                    cb: () => {
                        setLoading(false);
                    },
                    getFieldErrorsCb: (errorStr: string) => {
                        setFormErrorValue(errorStr);
                    }
                };
                extractErrorMessage(errorData);
            });
    }
    const onSubmitConfirmSignUpForm = (values: TConfirmValues) => {
        const params = {
            ...values,
            username,
        };
        axios.post(`${baseUrl}api/auth/confirm/email`, params)
            .then(() => {
                setLoading(false);
                if (isQuickUse && onSignedUpSuccess) {
                    onSignedUpSuccess();
                    return;
                }
                navigate('/');
            })
            .catch((error) => {
                const errorData = {
                    error: error,
                    show: show,
                    cb: () => {
                        setLoading(false);
                    }
                };
                extractErrorMessage(errorData);
            });
    }
    const resendCode = () => {
        axios.post(`${baseUrl}api/auth/confirm/resend`, { username })
            .then(() => {
                setLoading(false);
            })
            .catch((error) => {
                const errorData = {
                    error: error,
                    show: show,
                    cb: () => {
                        setLoading(false);
                    }
                };
                extractErrorMessage(errorData);
            });
    }

    if (isQuickUse) {
        return (
            <div className={styles.quickUseWrapper}>
                <div className={styles.holder}>
                    {
                        Boolean(username) ? (
                            <ConfirmSignUpForm
                                onSubmit={onSubmitConfirmSignUpForm}
                                isLoading={isLoading}
                                resendCode={resendCode}
                            />
                        ) : (
                            <SignUpForm
                                onSubmit={onSubmitSignUpForm}
                                isLoading={isLoading}
                                invitedUserEmail={decodedEmail}
                                formError={formError}
                                invitedUserName={name || ''}
                                clearFormError={clearFormError}
                            />
                        )
                    }
                </div>
            </div>
        )
    }

    return (
        <div className={styles.authentication}>
            <div className={styles.holder}>
                <div className={styles.logoRow}>
                    <img src={logo} alt=""/>
                </div>
                {
                    Boolean(username) ? (
                        <ConfirmSignUpForm
                            onSubmit={onSubmitConfirmSignUpForm}
                            isLoading={isLoading}
                            resendCode={resendCode}
                        />
                    ) : (
                        <SignUpForm
                            onSubmit={onSubmitSignUpForm}
                            isLoading={isLoading}
                            invitedUserEmail={decodedEmail}
                            formError={formError}
                            invitedUserName={name || ''}
                            clearFormError={clearFormError}
                        />
                    )
                }
                <p className={styles.terms}>
                    © {moment().format("YYYY")}  Corpora, Inc.
                </p>
            </div>
        </div>
    )
}

export default SignUp;
